"use client";

import { useState } from "react";
import Link from "next/link";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resetToken, setResetToken] = useState("");

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const res = await fetch("/api/auth/forgot-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await res.json();

            if (!res.ok) {
                setError(data.detail || "Error al solicitar reset");
                return;
            }

            setSuccess(true);
            // DEV: mostrar token (eliminar en producción)
            if (data.token) {
                setResetToken(data.token);
            }
        } catch (err) {
            setError("Error de conexión");
        } finally {
            setLoading(false);
        }
    }

    if (success) {
        return (
            <main className="min-h-screen bg-black flex items-center justify-center p-4">
                <div className="w-full max-w-sm bg-zinc-900 rounded-xl p-6">
                    <h1 className="text-2xl font-semibold mb-4 text-center">
                        ✉️ Revisa tu email
                    </h1>
                    <p className="text-sm text-zinc-400 text-center mb-4">
                        Si el email existe, recibirás instrucciones para resetear tu contraseña.
                    </p>

                    {/* DEV: Mostrar token */}
                    {resetToken && (
                        <div className="bg-yellow-900/20 border border-yellow-600 rounded p-3 mb-4">
                            <div className="text-xs text-yellow-400 mb-1">🔧 DEV MODE</div>
                            <div className="text-xs text-zinc-300 break-all">
                                Token: {resetToken}
                            </div>
                            <Link
                                href={`/reset-password?token=${resetToken}`}
                                className="text-xs text-emerald-400 hover:text-emerald-300 block mt-2"
                            >
                                → Ir a reset password
                            </Link>
                        </div>
                    )}

                    <Link
                        href="/login"
                        className="block text-center text-sm text-emerald-400 hover:text-emerald-300"
                    >
                        ← Volver al login
                    </Link>
                </div>
            </main>
        );
    }

    return (
        <main className="min-h-screen bg-black flex items-center justify-center p-4">
            <div className="w-full max-w-sm bg-zinc-900 rounded-xl p-6">
                <h1 className="text-2xl font-semibold mb-2 text-center">
                    ¿Olvidaste tu contraseña?
                </h1>
                <p className="text-sm text-zinc-400 text-center mb-6">
                    Introduce tu email y te enviaremos instrucciones
                </p>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm text-zinc-400 mb-1">
                            Email
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full bg-zinc-800 border border-zinc-700 rounded px-3 py-2 text-sm"
                        />
                    </div>

                    {error && (
                        <div className="text-red-400 text-sm text-center">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-emerald-600 hover:bg-emerald-500 text-white py-2 rounded disabled:opacity-50"
                    >
                        {loading ? "Enviando..." : "Enviar instrucciones"}
                    </button>
                </form>

                <div className="mt-4 text-center">
                    <Link
                        href="/login"
                        className="text-sm text-zinc-400 hover:text-emerald-400"
                    >
                        ← Volver al login
                    </Link>
                </div>
            </div>
        </main>
    );
}